import { ChangeDetectionStrategy, Component, Host, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableCellBase } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-cell-base';
import { ICreateChangeBase } from '@fi-shared/models/models';
import { SharedActionsBaseService } from '@fi-shared/fi-shared-services/shared-actions-base.service';
import { FiDateFormatOptions } from '@fi-shared/utils';

@Component({
    selector: 'fi-wrapper-table-changed-on-cell',
    templateUrl: './fi-wrapper-table-changed-on-cell.component.html',
    styleUrls: ['./fi-wrapper-table-changed-on-cell.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-wrapper-table-changed-on-cell' },
    standalone: false,
})
export class FiWrapperTableChangedOnCellComponent extends FiWrapperTableCellBase<ICreateChangeBase> {
    @Input() isChangedByDataShown: boolean = true;
    @Input() fiDateFormatRegistry: Intl.DateTimeFormatOptions = FiDateFormatOptions;
    @Input() datePropName: string = 'ChangedOn';

    private _minDate = new Date(1900, 1, 1);

    constructor(private sharedActionsService: SharedActionsBaseService) {
        super();
    }

    get itemDateStr(): string | undefined {
        return this.value?.[this.datePropName];
    }

    @HostBinding('class.hidden')
    get isChangedOnCorrect() {
        const changedOn = new Date(this.value?.[this.datePropName]);
        return changedOn < this._minDate;
    }

    protected openUserViewDialog($event: MouseEvent, itemChangedByUserId: number): void {
        $event.stopPropagation();
        this.sharedActionsService.openUserViewPopup(itemChangedByUserId);
    }
}
